import { useSelector } from 'react-redux';

export function useFieldValues() {
  return useSelector(state => state.ui.fieldValues);
}
